import { Button, Dialog, IconButton, Stack, Typography } from "@mui/material";
import Iconify from "src/components/iconify";

interface ConfirmDeleteDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}


export default function ConfirmDeleteDialog({
    open,
    onClose,
    onConfirm,
}: ConfirmDeleteDialogProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="xs"
        >
            <Stack
                p={2}
                spacing={2}
            >
                <Stack direction='row' justifyContent='space-between' alignItems='center'>
                    <Typography
                        variant="h6"
                        color='error'
                    >
                        Deletar Banners
                    </Typography>
                    <IconButton
                        onClick={onClose}
                    >
                        <Iconify icon='lucide:x' />
                    </IconButton>
                </Stack>
                <Stack>
                    <Typography
                        variant="body2"
                    >
                        Atenção! Essa ação é irreversível. Tem certeza que deseja deletar os banners selecionados?
                    </Typography>
                </Stack>
                <Stack direction='row' justifyContent='flex-end' spacing={1} mt={2}>
                    <Button
                        variant="contained"
                        onClick={onClose}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => { onConfirm(); onClose(); }}
                    >
                        Deletar
                    </Button>
                </Stack>
            </Stack>
        </Dialog>
    )
}